import DelBox from "../comps/DelBox";
import React from "react";
import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function StoreSales() {
  // ================================================================
  //  COMMON STATE
  // ================================================================
  const [activeTab, setActiveTab] = useState("sale");
  const [ldata, setLdata] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [image, setImage] = useState("");



// Stock - View Story Modal
const [showStoryModal, setShowStoryModal] = useState(false);
const [storyData, setStoryData] = useState(null);
const [storyRecords, setStoryRecords] = useState([]);
const [storyLoading, setStoryLoading] = useState(false);

// Stock - Manual Reduce Modal
const [showManualModal, setShowManualModal] = useState(false);
const [manualItem, setManualItem] = useState(null);
const [manualQty, setManualQty] = useState(1);
const [manualRemarks, setManualRemarks] = useState("");
const [manualPatientSearch, setManualPatientSearch] = useState("");
const [manualPatientList, setManualPatientList] = useState([]);
const [manualSelectedPatient, setManualSelectedPatient] = useState(null);
const [manualSaving, setManualSaving] = useState(false);







  // ================================================================
  //  SALE TAB STATE
  // ================================================================
  const [formData, setFormData] = useState({
    l1: [],
    filteredData: [],
    search_key: "",
    from: "",
    to: "",
  });
  const [loading, setLoading] = useState(false);

  // View Modal
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewSaleDetails, setViewSaleDetails] = useState(null);
  const [viewItems, setViewItems] = useState([]);
  const [viewReturnItems, setViewReturnItems] = useState([]);
  const [viewReturns, setViewReturns] = useState([]);

  // ================================================================
  //  RETURN TAB STATE
  // ================================================================
  const [returnSalesList, setReturnSalesList] = useState([]);
  const [returnFilteredList, setReturnFilteredList] = useState([]);
  const [returnSearchKey, setReturnSearchKey] = useState("");
  const [returnLoading, setReturnLoading] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnSaleData, setReturnSaleData] = useState(null);
  const [returnItems, setReturnItems] = useState([]);
  const [returnRemarks, setReturnRemarks] = useState("");
  const [returnSaving, setReturnSaving] = useState(false);
  const [savedReturnData, setSavedReturnData] = useState(null);

  // ================================================================
  //  STOCK TAB STATE
  // ================================================================
  const [stockList, setStockList] = useState([]);
  const [stockFiltered, setStockFiltered] = useState([]);
  const [stockSearchKey, setStockSearchKey] = useState("");
  const [stockLoading, setStockLoading] = useState(false);

  // ================================================================
  //  HELPERS
  // ================================================================
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatBillDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const day = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${day}-${months[d.getMonth()]}-${d.getFullYear()}`;
  };

  const getTodayDate = () => new Date().toISOString().split("T")[0];

  const numberToWords = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "";
    num = Math.round(Number(num));
    const a = ["","one ","two ","three ","four ","five ","six ","seven ","eight ","nine ",
      "ten ","eleven ","twelve ","thirteen ","fourteen ","fifteen ",
      "sixteen ","seventeen ","eighteen ","nineteen "];
    const b = ["","","twenty ","thirty ","forty ","fifty ","sixty ","seventy ","eighty ","ninety "];
    if (num === 0) return "Zero Only";
    if (num.toString().length > 9) return "Overflow";
    const n = ("000000000" + num).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return "";
    let str = "";
    str += n[1] != 0 ? (a[Number(n[1])] || b[n[1][0]] + a[n[1][1]]) + "Crore " : "";
    str += n[2] != 0 ? (a[Number(n[2])] || b[n[2][0]] + a[n[2][1]]) + "Lakh " : "";
    str += n[3] != 0 ? (a[Number(n[3])] || b[n[3][0]] + a[n[3][1]]) + "Thousand " : "";
    str += n[4] != 0 ? (a[Number(n[4])] || b[n[4][0]] + a[n[4][1]]) + "Hundred " : "";
    str += n[5] != 0 ? (str !== "" ? "And " : "") + (a[Number(n[5])] || b[n[5][0]] + a[n[5][1]]) : "";
    return str.trim().replace(/\s+/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()) + " Only";
  };

  
  const handleViewStory = async (item) => {
    setStoryData(item);
    setShowStoryModal(true);
    setStoryLoading(true);
    try {
      const fd = new FormData();
      fd.append("store_purchase_item_id", item.store_purchase_item_id);
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getStockUsageHistoryUrl,
        fd
      );
      if (res.data.status) {
        setStoryRecords(res.data.records || []);
        // ✅ Merge fresh item details so storyData has store_purchase_item_qty
        if (res.data.item_details) {
          setStoryData((prev) => ({ ...prev, ...res.data.item_details }));
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Error loading usage history");
    } finally {
      setStoryLoading(false);
    }
  };

// Manual Reduce - Open Modal
const handleOpenManualReduce = (item) => {
  setManualItem(item);
  setManualQty(1);
  setManualRemarks("");
  setManualPatientSearch("");
  setManualPatientList([]);
  setManualSelectedPatient(null);
  setShowManualModal(true);
};

// Manual Reduce - Search Patient
const searchPatient = async (key) => {
  setManualPatientSearch(key);
  if (key.length < 2) {
    setManualPatientList([]);
    return;
  }
  try {
    const fd = new FormData();
    fd.append("search", key);
    const res = await axios.post(
      AppConst.BASE_URL + AppConst.getPatientsForStockUseUrl,
      fd
    );
    if (res.data.status) {
      setManualPatientList(res.data.records || []);
    }
  } catch (err) {
    console.error(err);
  }
};

// Manual Reduce - Save
const handleManualReduceSave = async () => {
  if (!manualSelectedPatient) {
    toast.error("Please select a patient!");
    return;
  }
  if (manualQty < 1) {
    toast.error("Quantity must be at least 1!");
    return;
  }
  if (manualQty > parseInt(manualItem.store_purchase_test_qty || 0)) {
    toast.error(`Insufficient stock. Available: ${manualItem.store_purchase_test_qty}`);
    return;
  }

  setManualSaving(true);
  try {
    const fd = new FormData();
    fd.append("store_purchase_item_id", manualItem.store_purchase_item_id);
    fd.append("lab_reg_id", manualSelectedPatient.lab_reg_id);
    fd.append("qty", manualQty);
    fd.append("remarks", manualRemarks || "Manual reduction");
    fd.append("user_id", ldata?.user_id || "");

    const res = await axios.post(
      AppConst.BASE_URL + AppConst.manualReduceStockUrl,
      fd
    );

    if (res.data.status) {
      toast.success(res.data.success);
      setShowManualModal(false);
      fetchStockList();
    } else {
      toast.error(res.data.success || "Error reducing stock");
    }
  } catch (err) {
    console.error(err);
    toast.error("Error reducing stock");
  } finally {
    setManualSaving(false);
  }
};
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      if (!blob.type.startsWith("image/")) return null;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  };

  // ================================================================
  //  FETCH CONFIG
  // ================================================================
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL}${AppConst.getconfig}?config_type=lab`);
      if (res.data.status) setImage(res.data.header_logo);
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  // ================================================================
  //  SALE TAB — FETCH / FILTER / VIEW / EDIT / DELETE
  // ================================================================
  const initData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(AppConst.BASE_URL + AppConst.getStoreSalesUrl);
      if (response.data.status) {
        const records = response.data.records || [];
        setFormData((prev) => ({ ...prev, l1: records, filteredData: records }));
      }
    } catch (error) {
      console.error("Error fetching sales:", error);
      toast.error("Error loading sales data");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = (data = formData.l1) => {
    let filtered = [...data];
    if (formData.search_key) {
      const s = formData.search_key.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          (item.store_purchase_no && item.store_purchase_no.toString().includes(s)) ||
          (item.patient_name && item.patient_name.toLowerCase().includes(s)) ||
          (item.patient_mobile && item.patient_mobile.includes(s)) ||
          (item.store_department && item.store_department.toLowerCase().includes(s))
      );
    }
    if (formData.from) {
      filtered = filtered.filter((item) => new Date(item.store_purchase_date) >= new Date(formData.from));
    }
    if (formData.to) {
      filtered = filtered.filter((item) => new Date(item.store_purchase_date) <= new Date(formData.to));
    }
    setFormData((prev) => ({ ...prev, filteredData: filtered }));
  };

  useEffect(() => {
    applyFilters();
  }, [formData.search_key, formData.from, formData.to, formData.l1]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFormData((prev) => ({ ...prev, search_key: "", from: "", to: "", filteredData: prev.l1 }));
  };

  // ── VIEW — shows original sale items + return items separately ──
  const handleView = async (sale) => {
    try {
      const fd = new FormData();
      fd.append("sale_id", sale.store_sale_id);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getSaleDetailsUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.data.status) {
        setViewSaleDetails(response.data.sale);
        setViewItems(response.data.items || []);
        setViewReturnItems(response.data.return_items || []);
        setViewReturns(response.data.returns || []);
        setShowViewModal(true);
      }
    } catch (error) {
      console.error("Error fetching sale details:", error);
      toast.error("Error loading sale details");
    }
  };

  const handleEdit = (sale) => {
    sessionStorage.setItem("opd_dt", JSON.stringify({ ...sale, items: [] }));
    window.location.href = "/new_sale";
  };

  const handleDelete = async (sale) => {
    if (!window.confirm(`Are you sure you want to delete Sale #${sale.store_purchase_no}?`)) return;
    try {
      const fd = new FormData();
      fd.append("store_sale_id", sale.store_sale_id);
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.deleteStoreSaleUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response.data.status) {
        toast.success("Sale deleted successfully");
        initData();
      } else {
        toast.error(response.data.message || "Failed to delete sale");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Error deleting sale");
    }
  };

  // Sale DataTable columns — original amounts, no changes
  const saleColumns = [
    { name: "#", selector: (_, i) => i + 1, sortable: false, width: "60px" },
    { name: "Sale No", selector: (r) => r.store_purchase_no, sortable: true, width: "120px" },
    { name: "Date", selector: (r) => formatDate(r.store_purchase_date), sortable: true, width: "120px" },
    { name: "Patient", selector: (r) => r.patient_name || "-", sortable: true },
    { name: "Age", selector: (r) => r.patient_age || "-", sortable: true, width: "80px" },
    { name: "Mobile", selector: (r) => r.patient_mobile || "-", sortable: true, width: "130px" },
    { name: "Department", selector: (r) => r.store_department || "-", sortable: true },
    { name: "Items", selector: (r) => r.total_items || 0, sortable: true, width: "80px" },
    {
      name: "Total Amount",
      selector: (r) => parseFloat(r.total_amount || 0),
      sortable: true,
      width: "130px",
      cell: (r) => `₹${parseFloat(r.total_amount || 0).toFixed(2)}`,
    },
    {
      name: "Status",
      width: "110px",
      cell: (row) => {
        const hasReturn = parseInt(row.return_count || 0) > 0;
        return hasReturn ? (
          <span className="badge bg-warning text-dark">
            <i className="ri-arrow-go-back-line me-1"></i>Returned
          </span>
        ) : (
          <span className="badge bg-success">Completed</span>
        );
      },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button className="btn btn-sm btn-info" onClick={() => handleView(row)} title="View">
            <i className="ri-eye-line"></i>
          </button>
          {isAdmin && (
            <>
              <button className="btn btn-sm btn-primary" onClick={() => handleEdit(row)} title="Edit">
                <i className="ri-pencil-line"></i>
              </button>
              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row)} title="Delete">
                <i className="ri-delete-bin-line"></i>
              </button>
            </>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "150px",
    },
  ];

  // ================================================================
  //  RETURN TAB
  // ================================================================
  const fetchReturnSalesList = async () => {
    setReturnLoading(true);
    try {
      const response = await axios.get(AppConst.BASE_URL + AppConst.getStoreSalesUrl);
      if (response.data.status) {
        const records = response.data.records || [];
        setReturnSalesList(records);
        setReturnFilteredList(records);
      }
    } catch (error) {
      console.error("Error fetching sales for return:", error);
      toast.error("Error loading sales");
    } finally {
      setReturnLoading(false);
    }
  };

  useEffect(() => {
    if (!returnSearchKey) {
      setReturnFilteredList(returnSalesList);
      return;
    }
    const s = returnSearchKey.toLowerCase();
    setReturnFilteredList(
      returnSalesList.filter(
        (item) =>
          (item.store_purchase_no && item.store_purchase_no.toString().includes(s)) ||
          (item.patient_name && item.patient_name.toLowerCase().includes(s)) ||
          (item.patient_mobile && item.patient_mobile.includes(s))
      )
    );
  }, [returnSearchKey, returnSalesList]);

  // Open return popup — loads ORIGINAL items + already returned info
  const openReturnModal = async (sale) => {
    try {
      const fd = new FormData();
      fd.append("sale_id", sale.store_sale_id);
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getSaleDetailsUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status) {
        const saleInfo = res.data.sale;
        const items = res.data.items || [];
        const existingReturnItems = res.data.return_items || [];

        // Build map: how much already returned per sale_item_id
        const returnedMap = {};
        existingReturnItems.forEach((ri) => {
          const key = ri.store_sale_item_id || ri.store_purchase_item_id;
          returnedMap[key] = (returnedMap[key] || 0) + parseInt(ri.return_qty || 0);
        });

        setReturnSaleData(saleInfo);
        setReturnItems(
          items.map((item) => {
            const alreadyReturned = returnedMap[item.store_sale_item_id] || 0;
            const remainingQty = parseInt(item.qty) - alreadyReturned;
            return {
              ...item,
              return_qty: 0,
              already_returned: alreadyReturned,
              max_qty: remainingQty > 0 ? remainingQty : 0,
              original_qty: parseInt(item.qty),
            };
          })
        );
        setReturnRemarks("");
        setShowReturnModal(true);
      }
    } catch (err) {
      console.error(err);
      toast.error("Error loading sale details");
    }
  };

  const handleReturnQtyChange = (index, value) => {
    const val = parseInt(value) || 0;
    if (val < 0) return;
    if (val > returnItems[index].max_qty) {
      toast.error(`Max returnable qty is ${returnItems[index].max_qty} (already returned: ${returnItems[index].already_returned})`);
      return;
    }
    const updated = [...returnItems];
    updated[index].return_qty = val;
    setReturnItems(updated);
  };

  // ── SAVE RETURN — uses save_store_sale with operation_type=return ──
  // Does NOT modify original sale total_amount or sale items qty
  const handleSaveReturn = async () => {
    const itemsToReturn = returnItems.filter((i) => i.return_qty > 0);
    if (itemsToReturn.length === 0) {
      toast.error("Enter return quantity for at least one item!");
      return;
    }

    setReturnSaving(true);
    try {
      const fd = new FormData();
      fd.append("operation_type", "return");
      fd.append("store_sale_id", returnSaleData.store_sale_id);
      fd.append("store_purchase_no", returnSaleData.store_purchase_no);
      fd.append("store_purchase_date", getTodayDate());
      fd.append("patient_name", returnSaleData.patient_name || "");
      fd.append("patient_age", returnSaleData.patient_age || "");
      fd.append("patient_gender", returnSaleData.patient_gender || "");
      fd.append("patient_address", returnSaleData.patient_address || "");
      fd.append("patient_mobile", returnSaleData.patient_mobile || "");
      fd.append("doctor_id", returnSaleData.doctor_id || "");
      fd.append("store_department", returnSaleData.store_department || "");
      fd.append("remarks", returnRemarks || "Sale Return");
      fd.append("user_id", ldata?.user_id || "");
      fd.append(
        "items",
        JSON.stringify(
          itemsToReturn.map((i) => ({
            store_sale_item_id: i.store_sale_item_id,
            store_purchase_item_id: i.store_purchase_item_id,
            store_purchase_item_name: i.store_purchase_item_name,
            store_purchase_item_unit: i.store_purchase_item_unit || "",
            store_batch_no: i.store_batch_no || "",
            price: i.price,
            qty: i.return_qty,
            return_qty: i.return_qty,
            original_qty: i.original_qty,
          }))
        )
      );

      const res = await axios.post(AppConst.BASE_URL + AppConst.saveStoreSaleUrl, fd);

      if (res.data.status) {
        toast.success("Return saved successfully!");
        // Store data for separate print
        setSavedReturnData({
          sale: { ...returnSaleData },
          items: itemsToReturn.map((i) => ({ ...i })),
          response: res.data,
        });
        setShowReturnModal(false);
        fetchReturnSalesList();
        initData();
        fetchStockList();
      } else {
        toast.error(res.data.message || "Error saving return");
      }
    } catch (err) {
      console.error("Return save error:", err);
      toast.error("Error saving return");
    } finally {
      setReturnSaving(false);
    }
  };

  // Return PDF
  const generateReturnPDF = async (sale, items, responseData) => {
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 30;
    let y = 40;

    const b64 = await imageUrlToBase64(image);
    if (b64) { doc.addImage(b64, "PNG", 0, 0, pageWidth, 80); y = 100; }

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("SALE RETURN", pageWidth / 2, y, { align: "center" });
    y += 25;

    const boxH = 100;
    doc.rect(margin, y, pageWidth - 2 * margin, boxH);
    let lx = margin + 10, rx = pageWidth / 2 + 40, ly = y + 18;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text(`Patient Name: ${sale.patient_name || "N/A"}`, lx, ly);
    doc.text(`Return Date: ${formatBillDate(getTodayDate())}`, rx, ly);
    ly += 15;
    doc.text(`Age: ${sale.patient_age || "N/A"} years`, lx, ly);
    doc.text(`Original Sale No: ${sale.store_purchase_no || "N/A"}`, rx, ly);
    ly += 15;
    doc.text(`Gender: ${sale.patient_gender || "N/A"}`, lx, ly);
    doc.text(`Sale Date: ${formatBillDate(sale.store_purchase_date)}`, rx, ly);
    ly += 15;
    doc.text(`Mobile: ${sale.patient_mobile || "N/A"}`, lx, ly);
    doc.text(`Department: ${sale.store_department || "N/A"}`, rx, ly);
    ly += 15;
    const wrAddr = doc.splitTextToSize(`Address: ${sale.patient_address || "N/A"}`, pageWidth / 2 - 60);
    doc.text(wrAddr, lx, ly);
    y += boxH + 15;

    if (returnRemarks && returnRemarks.trim()) {
      doc.setFont("helvetica", "bold"); doc.setFontSize(10);
      doc.text("Return Remarks:", margin, y);
      doc.setFont("helvetica", "normal"); doc.setFontSize(9);
      const rl = doc.splitTextToSize(returnRemarks, pageWidth - 2 * margin);
      doc.text(rl, margin, y + 13);
      y += rl.length * 12 + 20;
    }

    const body = items.map((item, i) => {
      const p = parseFloat(item.price || 0);
      const rq = parseInt(item.return_qty || 0);
      const soldQty = parseInt(item.original_qty || item.qty || 0);
      return [i + 1, item.store_purchase_item_name || "", item.store_batch_no || "-",
        item.store_purchase_item_unit || "-", soldQty, rq, `${p.toFixed(2)}`, `${(p * rq).toFixed(2)}`];
    });

    autoTable(doc, {
      startY: y,
      head: [["#", "Item Name", "Batch No", "Unit", "Sold Qty", "Return Qty", "Price", "Return Total"]],
      body,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 4, lineColor: [200, 200, 200], lineWidth: 0.5 },
      headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold", halign: "center", fontSize: 9 },
      columnStyles: { 0: { cellWidth: 25, halign: "center" }, 4: { halign: "center" }, 5: { halign: "center" }, 6: { halign: "right" }, 7: { halign: "right" } },
      margin: { left: margin, right: margin, bottom: 60 },
    });

    y = doc.lastAutoTable.finalY + 20;
    const returnTotal = items.reduce((sum, item) => sum + parseFloat(item.price || 0) * parseInt(item.return_qty || 0), 0);

    if (y > pageHeight - 120) { doc.addPage(); y = 50; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(11);
    doc.text("Return Grand Total:", pageWidth - margin - 170, y);
    doc.text(`${returnTotal.toFixed(2)}`, pageWidth - margin, y, { align: "right" });
    y += 18;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9);
    const wAmt = doc.splitTextToSize(`Amount in Words: ${numberToWords(returnTotal)}`, pageWidth - 2 * margin);
    doc.text(wAmt, margin, y);
    y += wAmt.length * 12 + 30;

    if (y > pageHeight - 80) { doc.addPage(); y = 50; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(9);
    const lsx = margin + 80, rsx = pageWidth - margin - 80;
    doc.line(margin, y, lsx * 2 - margin, y);
    doc.text("Customer Signature", lsx, y + 15, { align: "center" });
    doc.line(pageWidth / 2 + 40, y, pageWidth - margin, y);
    doc.text("Authorized Signature", rsx, y + 15, { align: "center" });

    const tp = doc.internal.getNumberOfPages();
    // for (let i = 1; i <= tp; i++) {
    //   doc.setPage(i);
    //   doc.setFont("helvetica", "normal"); doc.setFontSize(8);
    //   doc.text(`Page ${i} of ${tp}`, pageWidth / 2, pageHeight - 20, { align: "center" });
    //   doc.text(`Generated on ${new Date().toLocaleString()}`, pageWidth / 2, pageHeight - 10, { align: "center" });
    // }

    window.open(doc.output("bloburl"), "_blank");
  };

  // Print saved return (from just-saved data)
  const handlePrintReturn = async () => {
    if (!savedReturnData) {
      toast.error("Please save a return first!");
      return;
    }
    await generateReturnPDF(
      savedReturnData.sale,
      savedReturnData.items,
      savedReturnData.response
    );
  };

  // Print existing return — fetch from API and generate PDF
  const handlePrintExistingReturn = async (sale) => {
    try {
      const fd = new FormData();
      fd.append("sale_id", sale.store_sale_id);
      const res = await axios.post(
        AppConst.BASE_URL + AppConst.getSaleDetailsUrl,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (res.data.status) {
        const saleInfo = res.data.sale;
        const returnItemsList = res.data.return_items || [];
        const returns = res.data.returns || [];

        if (returnItemsList.length === 0) {
          toast.error("No return items found for this sale");
          return;
        }

        // Build items with return_qty for PDF
        const pdfItems = returnItemsList.map((ri) => ({
          store_purchase_item_name: ri.store_purchase_item_name,
          store_batch_no: ri.store_batch_no || "",
          store_purchase_item_unit: ri.store_purchase_item_unit || "",
          price: ri.price,
          return_qty: ri.return_qty,
          original_qty: 0, // not needed for print
          qty: ri.return_qty,
        }));

        const totalReturnAmount = returnItemsList.reduce(
          (sum, ri) => sum + parseFloat(ri.return_total || 0), 0
        );

        await generateReturnPDF(saleInfo, pdfItems, { return_total: totalReturnAmount });
      }
    } catch (err) {
      console.error("Error printing return:", err);
      toast.error("Error loading return details");
    }
  };

  // Return tab DataTable columns
  const returnColumns = [
    { name: "#", selector: (_, i) => i + 1, sortable: false, width: "60px" },
    { name: "Sale No", selector: (r) => r.store_purchase_no, sortable: true, width: "120px" },
    { name: "Date", selector: (r) => formatDate(r.store_purchase_date), sortable: true, width: "120px" },
    { name: "Patient", selector: (r) => r.patient_name || "-", sortable: true },
    { name: "Mobile", selector: (r) => r.patient_mobile || "-", sortable: true, width: "130px" },
    { name: "Department", selector: (r) => r.store_department || "-", sortable: true },
    { name: "Items", selector: (r) => r.total_items || 0, sortable: true, width: "70px", center: true },
    {
      name: "Total",
      selector: (r) => parseFloat(r.total_amount || 0),
      sortable: true, width: "120px",
      cell: (r) => `₹${parseFloat(r.total_amount || 0).toFixed(2)}`,
      right: true,
    },
    {
      name: "Return",
      width: "110px",
      cell: (row) => {
        const hasReturn = parseInt(row.return_count || 0) > 0;
        return hasReturn ? (
          <span className="badge bg-warning text-dark">
            <i className="ri-arrow-go-back-line me-1"></i>Returned
          </span>
        ) : (
          <span className="badge bg-light text-muted">No Return</span>
        );
      },
    },
    {
      name: "Action",
      cell: (row) => {
        const hasReturn = parseInt(row.return_count || 0) > 0;
        return (
          <div className="d-flex gap-1">
            <button className="btn btn-sm btn-warning" onClick={() => openReturnModal(row)} title="Return Items">
              <i className="ri-arrow-go-back-line me-1"></i>Return
            </button>
            {hasReturn && (
              <button className="btn btn-sm btn-info" onClick={() => handlePrintExistingReturn(row)} title="Print Return">
                <i className="ri-printer-fill"></i>
              </button>
            )}
          </div>
        );
      },
      ignoreRowClick: true, button: true, width: "180px",
    },
  ];

  // ================================================================
  //  STOCK TAB
  // ================================================================
  const fetchStockList = async () => {
    setStockLoading(true);
    try {
      const res = await axios.get(AppConst.BASE_URL + AppConst.getStoreStockUrl);
      if (res.data.status) {
        const records = res.data.records || [];
        setStockList(records);
        setStockFiltered(records);
      }
    } catch (err) {
      console.error("Error fetching stock:", err);
      toast.error("Error loading stock data");
    } finally {
      setStockLoading(false);
    }
  };

  useEffect(() => {
    if (!stockSearchKey) { setStockFiltered(stockList); return; }
    const s = stockSearchKey.toLowerCase();
    setStockFiltered(
      stockList.filter(
        (item) =>
          (item.store_purchase_item_name || "").toLowerCase().includes(s) ||
          (item.store_purchase_item_batch_no || item.store_batch_no || "").toLowerCase().includes(s)
      )
    );
  }, [stockSearchKey, stockList]);

  const stockColumns = [
    { name: "Sl No", selector: (_, i) => i + 1, sortable: false, width: "70px" },
    { name: "Item Name", selector: (r) => r.store_purchase_item_name || "-", sortable: true, grow: 2 },
    { name: "Batch No", selector: (r) => r.store_purchase_item_batch_no || r.store_batch_no || "-", sortable: true },
    {
      name: "Stock",
      selector: (r) => parseInt(r.item_stock || 0),
      sortable: true, width: "90px",
      cell: (r) => {
        const stock = parseInt(r.item_stock || 0);
        let cls = "badge bg-success";
        if (stock <= 0) cls = "badge bg-danger";
        else if (stock <= 10) cls = "badge bg-warning text-dark";
        return <span className={cls}>{stock}</span>;
      },
    },
    {
      name: "Lab Stock",
      selector: (r) => parseInt(r.store_purchase_test_qty || 0),
      sortable: true, width: "100px",
      cell: (r) => {
        const stock = parseInt(r.store_purchase_test_qty || 0);
        let cls = "badge bg-success";
        if (stock <= 0) cls = "badge bg-danger";
        else if (stock <= 10) cls = "badge bg-warning text-dark";
        return <span className={cls}>{stock}</span>;
      },
    },
    {
      name: "Actions",
      width: "200px",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-info"
            onClick={() => handleViewStory(row)}
            title="View Usage History"
          >
            <i className="ri-history-line me-1"></i>History
          </button>
          <button
            className="btn btn-sm btn-warning"
            onClick={() => handleOpenManualReduce(row)}
            title="Manual Reduce Stock"
            disabled={parseInt(row.store_purchase_test_qty || 0) <= 0}
          >
            <i className="ri-subtract-line me-1"></i>Reduce
          </button>
        </div>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  const exportStockPDF = async () => {
    const doc = new jsPDF("p", "pt", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 30;
    let y = 40;

    const b64 = await imageUrlToBase64(image);
    if (b64) { doc.addImage(b64, "PNG", 0, 0, pageWidth, 80); y = 100; }

    doc.setFont("helvetica", "bold"); doc.setFontSize(16);
    doc.text("STOCK REPORT", pageWidth / 2, y, { align: "center" });
    y += 12;
    doc.setFont("helvetica", "normal"); doc.setFontSize(9);
    doc.text(`Date: ${formatBillDate(getTodayDate())}`, pageWidth / 2, y + 8, { align: "center" });
    y += 25;

    const body = stockFiltered.map((item, i) => [
      i + 1, item.store_purchase_item_name || "-",
      item.store_purchase_item_batch_no || item.store_batch_no || "-",
      parseInt(item.item_stock || 0),
    ]);

    autoTable(doc, {
      startY: y,
      head: [["Sl No", "Item Name", "Batch No", "Stock"]],
      body,
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 5, lineColor: [200, 200, 200], lineWidth: 0.5 },
      headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: "bold", halign: "center", fontSize: 9 },
      columnStyles: { 0: { cellWidth: 50, halign: "center" }, 3: { cellWidth: 70, halign: "right" } },
      margin: { left: margin, right: margin, bottom: 40 },
    });

    const tp = doc.internal.getNumberOfPages();
    for (let i = 1; i <= tp; i++) {
      doc.setPage(i);
      doc.setFont("helvetica", "normal"); doc.setFontSize(8);
      doc.text(`Page ${i} of ${tp}`, pageWidth / 2, pageHeight - 20, { align: "center" });
      doc.text(`Generated on ${new Date().toLocaleString()}`, pageWidth / 2, pageHeight - 10, { align: "center" });
    }
    window.open(doc.output("bloburl"), "_blank");
  };

  // ================================================================
  //  EFFECTS
  // ================================================================
  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
      if (parseInt(parsed.role_id) === 1) setIsAdmin(true);
      initData();
      fetchConfigData();
    }
  }, []);

  useEffect(() => {
    if (activeTab === "return") fetchReturnSalesList();
    if (activeTab === "stock") fetchStockList();
  }, [activeTab]);

  const customStyles = {
    headRow: { style: { backgroundColor: "#f3f6f9", borderBottom: "2px solid #dee2e6", minHeight: "50px" } },
    headCells: { style: { fontSize: "13px", fontWeight: "600", color: "#495057", paddingLeft: "8px", paddingRight: "8px" } },
    cells: { style: { fontSize: "13px", paddingLeft: "8px", paddingRight: "8px" } },
  };

  // ================================================================
  //  RENDER
  // ================================================================
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Store Sales Management</h5>
                  </div>
                  {activeTab === "sale" && (
                    <div className="col-sm-auto">
                      <button type="button" onClick={() => { sessionStorage.removeItem("opd_dt"); window.location.href = "/new_sale"; }} className="btn btn-success">
                        <i className="ri-add-line align-bottom me-1"></i> New Sale
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="card-body pt-0">
                {/* ═══════════════ TABS ═══════════════ */}
                <ul className="nav nav-tabs nav-tabs-custom nav-justified mb-3" role="tablist">
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === "sale" ? "active" : ""}`} onClick={() => setActiveTab("sale")} style={{ cursor: "pointer" }}>
                      <i className="ri-shopping-cart-line me-1"></i> Sales
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === "return" ? "active" : ""}`} onClick={() => setActiveTab("return")} style={{ cursor: "pointer" }}>
                      <i className="ri-arrow-go-back-line me-1"></i> Sale Return
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className={`nav-link ${activeTab === "stock" ? "active" : ""}`} onClick={() => setActiveTab("stock")} style={{ cursor: "pointer" }}>
                      <i className="ri-stack-line me-1"></i> Stock
                    </a>
                  </li>
                </ul>

                {/* ═══════════════ SALE TAB ═══════════════ */}
                {activeTab === "sale" && (
                  <>
                    <div className="border border-dashed rounded p-3 mb-3">
                      <div className="row g-3">
                        <div className="col-md-3">
                          <label className="form-label">From Date</label>
                          <input className="form-control" type="date" name="from" onChange={handleChange} value={formData.from} />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">To Date</label>
                          <input className="form-control" type="date" name="to" onChange={handleChange} value={formData.to} />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">Search</label>
                          <input className="form-control" placeholder="Search by name, mobile, sale no..." type="text" name="search_key" onChange={handleChange} value={formData.search_key} />
                        </div>
                        <div className="col-md-3">
                          <label className="form-label">&nbsp;</label>
                          <div><button type="button" onClick={handleClear} className="btn btn-secondary w-100"><i className="ri-refresh-line me-1"></i> Clear Filters</button></div>
                        </div>
                      </div>
                    </div>
                    <DataTable columns={saleColumns} data={formData.filteredData} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 20, 30, 50]} highlightOnHover striped responsive customStyles={customStyles} progressPending={loading}
                      noDataComponent={<div className="text-center p-4"><h5 className="mt-2">No sales found</h5><p className="text-muted">Create your first sale to get started</p></div>} />
                  </>
                )}

                {/* ═══════════════ RETURN TAB ═══════════════ */}
                {activeTab === "return" && (
                  <>
                    <div className="border border-dashed rounded p-3 mb-3">
                      <div className="row g-3">
                        <div className="col-md-4">
                          <label className="form-label">Search Sale</label>
                          <input className="form-control" placeholder="Search by name, mobile, sale no..." type="text" value={returnSearchKey} onChange={(e) => setReturnSearchKey(e.target.value)} />
                        </div>
                        <div className="col-md-2">
                          <label className="form-label">&nbsp;</label>
                          <div><button type="button" onClick={() => setReturnSearchKey("")} className="btn btn-secondary w-100"><i className="ri-refresh-line me-1"></i> Clear</button></div>
                        </div>
                      </div>
                    </div>

                    {/* Print Return Button — shown after a return is saved */}
                    {savedReturnData && (
                      <div className="alert alert-success d-flex justify-content-between align-items-center mb-3">
                        <span>
                          <i className="ri-checkbox-circle-line me-1"></i>
                          Return saved for Sale #{savedReturnData.sale.store_purchase_no} — 
                          Return Total: <strong>₹{parseFloat(savedReturnData.response.return_total || 0).toFixed(2)}</strong>
                        </span>
                        <button type="button" className="btn btn-info" onClick={handlePrintReturn}>
                          <i className="ri-printer-fill me-1"></i> Print Return
                        </button>
                      </div>
                    )}
                    <DataTable columns={returnColumns} data={returnFilteredList} pagination paginationPerPage={10} paginationRowsPerPageOptions={[10, 20, 50]} highlightOnHover striped responsive customStyles={customStyles} progressPending={returnLoading}
                      noDataComponent={<div className="text-center p-4"><h5 className="mt-2">No sales found</h5><p className="text-muted">No sales available for return</p></div>} />
                  </>
                )}

                {/* ═══════════════ STOCK TAB ═══════════════ */}
                {activeTab === "stock" && (
                  <>
                    <div className="d-flex justify-content-between align-items-end mb-3">
                      <div style={{ maxWidth: "350px", flex: 1 }}>
                        <label className="form-label">Search Stock</label>
                        <input className="form-control" placeholder="Search by item name or batch no..." type="text" value={stockSearchKey} onChange={(e) => setStockSearchKey(e.target.value)} />
                      </div>
                      <button className="btn btn-danger" onClick={exportStockPDF}>
                        <i className="ri-file-pdf-line me-1"></i> Export PDF
                      </button>
                    </div>
                    <DataTable columns={stockColumns} data={stockFiltered} pagination paginationPerPage={15} paginationRowsPerPageOptions={[15, 30, 50, 100]} highlightOnHover striped responsive customStyles={customStyles} progressPending={stockLoading}
                      noDataComponent={<div className="text-center p-4"><h5 className="mt-2">No stock items found</h5></div>} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════════ VIEW SALE MODAL ═══════════════ */}
      {showViewModal && viewSaleDetails && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setShowViewModal(false)}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Sale Details - #{viewSaleDetails.store_purchase_no}
                  {viewReturns && viewReturns.length > 0 && (
                    <span className="badge bg-warning text-dark ms-2" style={{ fontSize: "12px" }}>
                      <i className="ri-arrow-go-back-line me-1"></i>Has Returns
                    </span>
                  )}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowViewModal(false)}></button>
              </div>
              <div className="modal-body">
                {/* Patient Info */}
                <div className="card mb-3">
                  <div className="card-body">
                    <h6 className="card-title">Patient Information</h6>
                    <div className="row">
                      <div className="col-md-3"><strong>Name:</strong><p>{viewSaleDetails.patient_name || "-"}</p></div>
                      <div className="col-md-3"><strong>Age:</strong><p>{viewSaleDetails.patient_age || "-"} years</p></div>
                      <div className="col-md-3"><strong>Gender:</strong><p>{viewSaleDetails.patient_gender || "-"}</p></div>
                      <div className="col-md-3"><strong>Mobile:</strong><p>{viewSaleDetails.patient_mobile || "-"}</p></div>
                      <div className="col-md-6"><strong>Address:</strong><p>{viewSaleDetails.patient_address || "-"}</p></div>
                      <div className="col-md-3"><strong>Department:</strong><p>{viewSaleDetails.store_department || "-"}</p></div>
                      <div className="col-md-3"><strong>Date:</strong><p>{formatDate(viewSaleDetails.store_purchase_date)}</p></div>
                      {viewSaleDetails.remarks && (<div className="col-md-12"><strong>Remarks:</strong><p>{viewSaleDetails.remarks}</p></div>)}
                    </div>
                  </div>
                </div>

                {/* ── ORIGINAL SALE ITEMS (never changed) ── */}
                <h6><i className="ri-shopping-cart-line me-1"></i> Original Sale Items</h6>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr><th>#</th><th>Item Name</th><th>Batch No</th><th>Unit</th><th>Qty</th><th>Price</th><th>Total</th></tr>
                    </thead>
                    <tbody>
                      {viewItems.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.store_purchase_item_name}</td>
                          <td>{item.store_batch_no}</td>
                          <td>{item.store_purchase_item_unit}</td>
                          <td>{item.qty}</td>
                          <td>₹{parseFloat(item.price).toFixed(2)}</td>
                          <td>₹{parseFloat(item.total).toFixed(2)}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot className="table-light">
                      <tr>
                        <th colSpan="6" className="text-end">Grand Total:</th>
                        <th>₹{parseFloat(viewSaleDetails.total_amount).toFixed(2)}</th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                {/* ── RETURN ITEMS (shown only if returns exist) ── */}
                {viewReturnItems && viewReturnItems.length > 0 && (
                  <div className="mt-4">
                    <h6 className="text-warning">
                      <i className="ri-arrow-go-back-line me-1"></i> Returned Items
                    </h6>

                    {viewReturns && viewReturns.length > 0 ? (
                      viewReturns.map((ret, rIdx) => {
                        const thisReturnItems = viewReturnItems.filter((ri) => ri.store_return_id == ret.store_return_id);
                        const retTotal = thisReturnItems.reduce((sum, ri) => sum + parseFloat(ri.return_total || 0), 0);

                        return (
                          <div key={rIdx} className="mb-3 border rounded p-2">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <small className="text-muted">
                                <strong>Return #{ret.store_return_id}</strong> &nbsp;|&nbsp; Date: {formatDate(ret.return_date)}
                                {ret.return_remarks && <> &nbsp;|&nbsp; Remarks: <em>{ret.return_remarks}</em></>}
                              </small>
                              <span className="badge bg-warning text-dark">Return Total: {retTotal.toFixed(2)}</span>
                            </div>
                            <div className="table-responsive">
                              <table className="table table-bordered table-sm mb-0">
                                <thead style={{ backgroundColor: "#fff3cd" }}>
                                  <tr><th>#</th><th>Item Name</th><th>Batch No</th><th>Unit</th><th>Return Qty</th><th>Price</th><th>Return Total</th></tr>
                                </thead>
                                <tbody>
                                  {thisReturnItems.map((ri, riIdx) => (
                                    <tr key={riIdx}>
                                      <td>{riIdx + 1}</td>
                                      <td>{ri.store_purchase_item_name}</td>
                                      <td>{ri.store_batch_no || "-"}</td>
                                      <td>{ri.store_purchase_item_unit || "-"}</td>
                                      <td className="text-center fw-bold text-danger">{ri.return_qty}</td>
                                      <td>{parseFloat(ri.price).toFixed(2)}</td>
                                      <td>{parseFloat(ri.return_total || 0).toFixed(2)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead style={{ backgroundColor: "#fff3cd" }}>
                            <tr><th>#</th><th>Item Name</th><th>Batch No</th><th>Return Qty</th><th>Price</th><th>Return Total</th></tr>
                          </thead>
                          <tbody>
                            {viewReturnItems.map((ri, riIdx) => (
                              <tr key={riIdx}>
                                <td>{riIdx + 1}</td>
                                <td>{ri.store_purchase_item_name}</td>
                                <td>{ri.store_batch_no || "-"}</td>
                                <td className="text-center fw-bold text-danger">{ri.return_qty}</td>
                                <td>{parseFloat(ri.price).toFixed(2)}</td>
                                <td>{parseFloat(ri.return_total || 0).toFixed(2)}</td>
                              </tr>
                            ))}
                          </tbody>
                          <tfoot style={{ backgroundColor: "#fff3cd" }}>
                            <tr>
                              <th colSpan="5" className="text-end">Total Returned:</th>
                              <th>₹{viewReturnItems.reduce((s, ri) => s + parseFloat(ri.return_total || 0), 0).toFixed(2)}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    )}

                    {/* Total Return Summary */}
                    <div className="alert alert-warning mt-2 mb-0 d-flex justify-content-between align-items-center">
                      <span><strong>Total Returned Amount:</strong></span>
                      <span className="fs-5 fw-bold">₹{viewReturnItems.reduce((s, ri) => s + parseFloat(ri.return_total || 0), 0).toFixed(2)}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowViewModal(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ═══════════════ RETURN MODAL ═══════════════ */}
      {showReturnModal && returnSaleData && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setShowReturnModal(false)}>
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: "#fff3cd" }}>
                <h5 className="modal-title">
                  <i className="ri-arrow-go-back-line me-2"></i>Sale Return — Sale #{returnSaleData.store_purchase_no}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowReturnModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3 g-2">
                  <div className="col-md-3">
                    <div className="border rounded p-2"><small className="text-muted">Patient</small><div className="fw-bold">{returnSaleData.patient_name || "-"}</div></div>
                  </div>
                  <div className="col-md-3">
                    <div className="border rounded p-2"><small className="text-muted">Sale Date</small><div className="fw-bold">{formatDate(returnSaleData.store_purchase_date)}</div></div>
                  </div>
                  <div className="col-md-3">
                    <div className="border rounded p-2"><small className="text-muted">Mobile</small><div className="fw-bold">{returnSaleData.patient_mobile || "-"}</div></div>
                  </div>
                  <div className="col-md-3">
                    <div className="border rounded p-2"><small className="text-muted">Sale Total (Original)</small><div className="fw-bold text-success">₹{parseFloat(returnSaleData.total_amount || 0).toFixed(2)}</div></div>
                  </div>
                </div>
                <hr />

                <h6 className="mb-3"><i className="ri-list-check me-1"></i> Sale Items — Enter Return Qty</h6>
                <div className="table-responsive">
                  <table className="table table-bordered align-middle">
                    <thead className="table-light">
                      <tr>
                        <th width="40">#</th>
                        <th>Item Name</th>
                        <th>Batch No</th>
                        <th>Unit</th>
                        <th width="80" className="text-center">Sold Qty</th>
                        <th width="100" className="text-center">Already Returned</th>
                        <th width="80" className="text-center">Remaining</th>
                        <th width="80" className="text-center">Price</th>
                        <th width="110" className="text-center">Return Qty</th>
                        <th width="100" className="text-end">Return Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {returnItems.map((item, index) => {
                        const retTotal = parseFloat(item.price || 0) * parseInt(item.return_qty || 0);
                        const allReturned = item.max_qty <= 0;
                        return (
                          <tr key={index} className={allReturned ? "table-secondary" : ""}>
                            <td>{index + 1}</td>
                            <td>
                              {item.store_purchase_item_name}
                              {allReturned && <span className="badge bg-danger ms-2">Fully Returned</span>}
                            </td>
                            <td>{item.store_batch_no || "-"}</td>
                            <td>{item.store_purchase_item_unit || "-"}</td>
                            <td className="text-center">{item.original_qty}</td>
                            <td className="text-center">
                              {item.already_returned > 0
                                ? <span className="badge bg-warning text-dark">{item.already_returned}</span>
                                : <span className="text-muted">0</span>}
                            </td>
                            <td className="text-center fw-bold">{item.max_qty}</td>
                            <td className="text-center">₹{parseFloat(item.price).toFixed(2)}</td>
                            <td>
                              <input type="number" className="form-control form-control-sm text-center" min="0" max={item.max_qty} value={item.return_qty}
                                onChange={(e) => handleReturnQtyChange(index, e.target.value)} disabled={allReturned} />
                            </td>
                            <td className="text-end fw-bold">₹{retTotal.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot className="table-warning">
                      <tr>
                        <th colSpan="9" className="text-end">Return Grand Total:</th>
                        <th className="text-end">
                          ₹{returnItems.reduce((sum, item) => sum + parseFloat(item.price || 0) * parseInt(item.return_qty || 0), 0).toFixed(2)}
                        </th>
                      </tr>
                    </tfoot>
                  </table>
                </div>

                <div className="mt-3">
                  <label className="form-label fw-bold">Return Remarks</label>
                  <textarea className="form-control" rows="2" value={returnRemarks} onChange={(e) => setReturnRemarks(e.target.value)} placeholder="Reason for return..." />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowReturnModal(false)}>
                  <i className="ri-close-line me-1"></i>Cancel
                </button>
                <button type="button" className="btn btn-warning" onClick={handleSaveReturn} disabled={returnSaving}>
                  {returnSaving
                    ? <><span className="spinner-border spinner-border-sm me-1"></span>Saving...</>
                    : <><i className="ri-save-line me-1"></i>Save Return</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}





      {/* ═══════════════ STOCK STORY MODAL ═══════════════ */}
{showStoryModal && storyData && (
  <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setShowStoryModal(false)}>
    <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: "#cfe2ff" }}>
          <h5 className="modal-title">
            <i className="ri-history-line me-2"></i>
            Usage History — {storyData.store_purchase_item_name}
            {storyData.store_purchase_item_batch_no && (
              <small className="ms-2 text-muted">Batch: {storyData.store_purchase_item_batch_no}</small>
            )}
          </h5>
          <button type="button" className="btn-close" onClick={() => setShowStoryModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="row mb-3 g-2">
            <div className="col-md-3">
              <div className="border rounded p-2">
                <small className="text-muted">Total Purchased Qty</small>
                <div className="fw-bold">{storyData.store_purchase_item_qty || 0}</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="border rounded p-2">
                <small className="text-muted">Current Lab Stock</small>
                <div className="fw-bold text-success">{storyData.store_purchase_test_qty || 0}</div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="border rounded p-2">
                <small className="text-muted">Total Used</small>
                <div className="fw-bold text-danger">
                  {storyRecords.reduce((s, r) => s + parseInt(r.qty_deducted || 0), 0)}
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="border rounded p-2">
                <small className="text-muted">Total Records</small>
                <div className="fw-bold">{storyRecords.length}</div>
              </div>
            </div>
          </div>

          {storyLoading ? (
            <div className="text-center p-4">
              <div className="spinner-border text-primary"></div>
              <p className="mt-2">Loading history...</p>
            </div>
          ) : storyRecords.length === 0 ? (
            <div className="alert alert-info text-center">
              <i className="ri-information-line me-1"></i> No usage history found for this item
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th width="50">#</th>
                    <th>Patient Name</th>
                    <th>UHID</th>
                    <th>Age</th>
                    <th>Test Name</th>
                    <th className="text-center">Qty Used</th>
                    <th className="text-center">Type</th>
                    <th>Date & Time</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {storyRecords.map((rec, idx) => (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className="fw-bold">{rec.patient_name || "-"}</td>
                      <td>{rec.patient_uhid || "-"}</td>
                      <td>{rec.patient_age || "-"}</td>
                      <td>{rec.test_name || "-"}</td>
                      <td className="text-center fw-bold text-danger">{rec.qty_deducted}</td>
                      <td className="text-center">
                        {rec.usage_type === "manual" ? (
                          <span className="badge bg-warning text-dark">Manual</span>
                        ) : (
                          <span className="badge bg-success">Auto</span>
                        )}
                      </td>
                      <td><small>{formatDate(rec.usage_datetime)} {rec.usage_datetime ? new Date(rec.usage_datetime).toLocaleTimeString() : ""}</small></td>
                      <td><small>{rec.remarks || "-"}</small></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowStoryModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{/* ═══════════════ MANUAL REDUCE STOCK MODAL ═══════════════ */}
{showManualModal && manualItem && (
  <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} onClick={() => setShowManualModal(false)}>
    <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: "#fff3cd" }}>
          <h5 className="modal-title">
            <i className="ri-subtract-line me-2"></i>
            Manual Stock Reduction — {manualItem.store_purchase_item_name}
          </h5>
          <button type="button" className="btn-close" onClick={() => setShowManualModal(false)}></button>
        </div>
        <div className="modal-body">
          <div className="alert alert-info">
            <strong>Current Lab Stock:</strong> {manualItem.store_purchase_test_qty || 0}
            {manualItem.store_purchase_item_batch_no && (
              <span className="ms-3"><strong>Batch:</strong> {manualItem.store_purchase_item_batch_no}</span>
            )}
          </div>

          <div className="mb-3 position-relative">
            <label className="form-label fw-bold">Search Patient (Name / UHID / Mobile) *</label>
            <input
              type="text"
              className="form-control"
              placeholder="Type at least 2 characters..."
              value={manualPatientSearch}
              onChange={(e) => {
                searchPatient(e.target.value);
                setManualSelectedPatient(null);
              }}
            />
            {manualPatientList.length > 0 && !manualSelectedPatient && (
              <div className="list-group position-absolute w-100 shadow" style={{ zIndex: 1000, maxHeight: "250px", overflowY: "auto" }}>
                {manualPatientList.map((p, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className="list-group-item list-group-item-action"
                    onClick={() => {
                      setManualSelectedPatient(p);
                      setManualPatientSearch(`${p.lab_reg_name} - ${p.lab_reg_uhid}`);
                      setManualPatientList([]);
                    }}
                  >
                    <strong>{p.lab_reg_name}</strong>
                    <small className="text-muted ms-2">
                      UHID: {p.lab_reg_uhid} | Age: {p.lab_reg_age} | Mobile: {p.lab_reg_mobile}
                    </small>
                  </button>
                ))}
              </div>
            )}
          </div>

          {manualSelectedPatient && (
            <div className="alert alert-success py-2">
              <strong>Selected:</strong> {manualSelectedPatient.lab_reg_name} 
              | UHID: {manualSelectedPatient.lab_reg_uhid} 
              | Age: {manualSelectedPatient.lab_reg_age}
            </div>
          )}

          <div className="mb-3">
            <label className="form-label fw-bold">Quantity to Reduce *</label>
            <input
              type="number"
              className="form-control"
              min="0"
              max={manualItem.store_purchase_test_qty || 0}
              value={manualQty}
              onChange={(e) => setManualQty(parseInt(e.target.value) || 1)}
            />
            <small className="text-muted">Max available: {manualItem.store_purchase_test_qty || 0}</small>
          </div>

          <div className="mb-3">
            <label className="form-label fw-bold">Remarks</label>
            <textarea
              className="form-control"
              rows="2"
              placeholder="Reason for manual reduction (e.g., Test repeated 2 times)"
              value={manualRemarks}
              onChange={(e) => setManualRemarks(e.target.value)}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowManualModal(false)}>
            <i className="ri-close-line me-1"></i>Cancel
          </button>
          <button type="button" className="btn btn-warning" onClick={handleManualReduceSave} disabled={manualSaving || !manualSelectedPatient}>
            {manualSaving
              ? <><span className="spinner-border spinner-border-sm me-1"></span>Saving...</>
              : <><i className="ri-save-line me-1"></i>Reduce Stock</>}
          </button>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default StoreSales;